import { ParticipationHeaderProps } from "./../types";
import { useSolutionHeaderProps } from "./useSolutionHeaderProps";
import { HeaderSolution } from "../../../../components/header-solution";

export function SolutionHeaderWrapper(props: ParticipationHeaderProps) {
  const headerProps = useSolutionHeaderProps(props);
  return <HeaderSolution {...headerProps} />;
}
